<template>
  <div class="video-play-button rounded-full">
    <div
      class="relative h-full w-full rounded-full border-4 border-solid border-white bg-blue-400 tablet:border-8"
    >
      <IconPlay
        class="absolute left-2/4 top-2/4 h-8 w-8 -translate-x-2/4 -translate-y-2/4 text-white"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @keyframes halo {
    0% {
      opacity: 0.8;
      transform: scale(1);
    }

    100% {
      opacity: 0;
      transform: scale(2);
    }
  }

  .video-play-button::before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 100%;
    background-color: #ffffff;
    animation: halo 2s infinite;
  }
</style>
